


import SECTION_1676511135550 from
'../dynamic_section/dynamic_2/template_01';






import HowItWorkSection from '../sections/how_it_work/template_01';


import SpeakerAnnouncement from '../sections/speaker_announcement/template_01';




import SECTION_FOOTER_BANNER from
'../dynamic_section/dynamic_2/template_01';



import "./style.css";


const HowItWorkPage = ()=>{
return (
  <div id="howItWorkPage" class="page ">
  
  

  
  < SECTION_1676511135550 desktopToggle={ true }
    mobileToggle={ false } label={ `tnc_title` } id={ `howitwork_title` } supportLanguage={
    true } titleToggle={ false } titleIconToggle={
    true } linkTo={ `` } addContainer={ false } />

< SECTION_1676511135550 desktopToggle={ false }
    mobileToggle={ true } label={ `tnc_title` } id={ `howitwork_title_m` } supportLanguage={
    true } titleToggle={ false } titleIconToggle={
    true } linkTo={ `` } addContainer={ false } />
  
  
  <SpeakerAnnouncement desktopToggle={ true } mobileToggle={
    false } iconToggle={ true } titleToggle={
    false } />
  

  
  <HowItWorkSection desktopTitleToggle={ false }
    mobileTitleToggle={ false } />
  
  
  
  

  
  < SECTION_FOOTER_BANNER desktopToggle={ true }
    mobileToggle={ false } label={ `Dynamic Section2` } id={ `mall_step` } supportLanguage={
    true } titleToggle={ false } titleIconToggle={
    true } linkTo={ `` } addContainer={ true } />
  
  < SECTION_FOOTER_BANNER desktopToggle={ false }
    mobileToggle={ true } label={ `Dynamic Section2` } id={ `mall_step_m` } supportLanguage={
      true } titleToggle={ false } titleIconToggle={
    true } linkTo={ `` } addContainer={ false } />
  
</div>
)
}

export default HowItWorkPage;